import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";

import ReactGA from "react-ga";

import TopNavigation from "../../components/TopNavigation/TopNavigation";

import FormStart from "../../components/FormStart/FormStart";
import FormSizeOfPlan from "../../components/FormSizeOfPlan/FormSizeOfPlan";
import FormStyleOfPlan from "../../components/FormStyleOfPlan/FormStyleOfPlan";
import FormBenefits from "../../components/FormBenefits/FormBenefits";
import FormChooseMySeats from "../../components/FormChooseMySeats/FormChooseMySeats";
import FormSelectYourSeat from "../../components/FormSelectYourSeat/FormSelectYourSeat";
import Checkout from "../../components/Checkout/Checkout";
import TicketLargeGroup from "../../components/TicketLargeGroup/TicketLargeGroup";
import classes from "./FormBuilder.module.scss";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import "../../Transition/fade.css";

import spinner from "../../assets/images/spinner.gif";

import * as CONSTANT from "../../constants/routes";
import SeatingMap from "../../components/FormSelectYourSeat/SeatingMap";

ReactGA.initialize("UA-71224221-38");
// ReactGA.pageview(window.location.pathname + window.location.search);

class FormBuilder extends Component {
  state = {
    choices: {
      [CONSTANT.PAGE_1_KEY]: ["single", "largeGroup", "package"],
      [CONSTANT.PAGE_2_KEY]: ["classic", "flexible", "ballpark"],
      [CONSTANT.PAGE_3_KEY]: [],
      [CONSTANT.PAGE_4_KEY]: {},
      [CONSTANT.PAGE_5_KEY]: ["recommend", "upsell", "downsell"],
    },
    selectedChoices: {
      [CONSTANT.PAGE_1_KEY]: "",
      [CONSTANT.PAGE_2_KEY]: "",
      [CONSTANT.PAGE_3_KEY]: "",
      [CONSTANT.PAGE_4_KEY]: {},
      [CONSTANT.PAGE_5_KEY]: "",
      selectYourSeatsUuid: "",
      buid: "",
      seatInfoSelected: "",
      numOfSeat: "",
    },
    cms: null,
  };

  updateSelectedChoices = (selectedChoicesKey, value) => {
    if (window.adobeAnalytics) {
      if (selectedChoicesKey === "formSize") {
        this.omnitureTracking(value);
      }
    }
    // console.log("here", { [selectedChoicesKey]: value });
    this.setState({
      selectedChoices: {
        ...this.state.selectedChoices,
        [selectedChoicesKey]: value,
      },
    });
  };

  updateMultipleSelectedChoices = (obj) => {
    this.setState({
      selectedChoices: {
        ...this.state.selectedChoices,
        ...obj,
      },
    });
  };

  omnitureTracking = (v) => {
    if (window.adobeAnalytics && window.adobeAnalytics.tl) {
      window.adobeAnalytics.tl(
        true,
        "o",
        `Washington Nationals: Tickets: Nationals Ticketfinder: Size of plan: ${v} : select click`,
        {
          prop12: "Nationals TicketFinder",
          prop13:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Size of plan",
          prop14: `${v} : select click`,
        }
      );
    }
  };

  componentDidMount() {
    fetch(
      `https://api${process.env.REACT_APP_DOMAIN}21.nationals.vipfanportal.com/styles`
    )
      .then((res) => (res.ok ? res : Promise.reject(res)))
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          cms: res,
        });
        this.createplans();
        // this.urlParamsHandler();
      });
  }
  urlParamsHandler() {
    setTimeout(() => {
      // let urlParams = new URL(document.location).searchParams;
      // const params = Object.fromEntries(urlParams);
      // console.log("FormBuilder -> urlParamsHandler -> params", params);

      // let redirect = urlParams.get("redirect");
      // console.log("FormBuilder -> urlParamsHandler -> redirect", redirect);

      // switch (redirect) {
      //   case "multiple/classic":
      //     setTimeout(() => {
      //       this.updateMultipleSelectedChoices({
      //         formStart: "multiple",
      //         formStyle: "classic",
      //       });
      //       this.props.history.push("/size-of-plan");
      //     }, 1500);
      //     break;
      //   case "multiple/flexible":
      //     setTimeout(() => {
      //       this.updateMultipleSelectedChoices({
      //         formStart: "multiple",
      //         formStyle: "flexible",
      //       });
      //       this.props.history.push("/size-of-plan");
      //     }, 1500);
      //     break;
      //   case "multiple/classic/82":
      //     setTimeout(() => {
      //       this.updateMultipleSelectedChoices({
      //         formStart: "multiple",
      //         formStyle: "classic",
      //         formSize: "eightyClassic",
      //       });
      //       this.props.history.push("/recommended-plan");
      //     }, 1500);
      //     break;
      //   case "multiple/classic/42":
      //     setTimeout(() => {
      //       this.updateMultipleSelectedChoices({
      //         formStart: "multiple",
      //         formStyle: "classic",
      //         formSize: "fortyClassic",
      //       });
      //       this.props.history.push("/recommended-plan");
      //     }, 1500);
      //     break;
      //   case "multiple/classic/22":
      //     setTimeout(() => {
      //       this.updateMultipleSelectedChoices({
      //         formStart: "multiple",
      //         formStyle: "classic",
      //         formSize: "twentyClassic",
      //       });
      //       this.props.history.push("/recommended-plan");
      //     }, 1500);
      //     break;
      //   case "multiple/flexible/80":
      //     setTimeout(() => {
      //       this.updateMultipleSelectedChoices({
      //         formStart: "multiple",
      //         formStyle: "flexible",
      //         formSize: "eightyFlexible",
      //       });
      //       this.props.history.push("/recommended-plan");
      //     }, 1500);
      //     break;
      //   case "multiple/flexible/40":
      //     setTimeout(() => {
      //       this.updateMultipleSelectedChoices({
      //         formStart: "multiple",
      //         formStyle: "flexible",
      //         formSize: "fortyFlexible",
      //       });
      //       this.props.history.push("/recommended-plan");
      //     }, 1500);
      //     break;

      //   default:
      //     break;
      // }
    }, 1000);
  }
  async createplans() {
    if (this.state.cms) {
      const _exclusivity = [];
      const _savings = [];
      const _convenience = [];
      const cms = this.state.cms;

      await cms.forEach(async (style, index) => {
        await style.plans.forEach(async (plan) => {
          if (plan.pageBenefits) {
            const _planName =
              plan.sizePlanChoice === "eightyBallpark"
                ? "ballPark"
                : plan.sizePlanChoice;
            plan.pageBenefits.exclusivity.forEach((benefit) => {
              const exclusivityMatch = _exclusivity.filter(function (e) {
                return e.label === benefit.name;
              });

              if (exclusivityMatch.length > 0) {
                const index = _exclusivity.findIndex(function (entry) {
                  return entry.label === exclusivityMatch[0].label;
                });
                _exclusivity[index].show.push(
                  `${_planName}-${style.name.toLowerCase()}`
                );
              } else {
                _exclusivity.push({
                  label: benefit.name,
                  selected: false,
                  show: [`${_planName}-${style.name.toLowerCase()}`],
                });
              }
            });

            plan.pageBenefits.savings.forEach((benefit) => {
              const savingsMatch = _savings.filter(function (e) {
                return e.label === benefit.name;
              });

              if (savingsMatch.length > 0) {
                const index = _savings.findIndex(function (entry) {
                  return entry.label === savingsMatch[0].label;
                });
                _savings[index].show.push(
                  `${_planName}-${style.name.toLowerCase()}`
                );
              } else {
                _savings.push({
                  label: benefit.name,
                  selected: false,
                  show: [`${_planName}-${style.name.toLowerCase()}`],
                });
              }
            });

            plan.pageBenefits.convenience.forEach((benefit) => {
              const convenienceMatch = _convenience.filter(function (e) {
                return e.label === benefit.name;
              });

              if (convenienceMatch.length > 0) {
                const index = _convenience.findIndex(function (entry) {
                  return entry.label === convenienceMatch[0].label;
                });
                _convenience[index].show.push(
                  `${_planName}-${style.name.toLowerCase()}`
                );
              } else {
                _convenience.push({
                  label: benefit.name,
                  selected: false,
                  show: [`${_planName}-${style.name.toLowerCase()}`],
                });
              }
            });
          }
        });
      });

      // itemsArray.sort(function(a, b){
      //   return sortingArr.indexOf(a) - sortingArr.indexOf(b);
      // });

      // console.log('_convenience', _convenience);

      this.setState({
        benefits: {
          exclusivity: _exclusivity,
          savings: _savings,
          convenience: _convenience,
        },
      });
    }
  }

  render() {
    return (
      <div className={classes.FormBuilder}>
        <TopNavigation data={this.state} />
        {!this.state.cms ||
        !this.state.benefits ||
        !this.state.benefits.exclusivity ||
        !this.state.benefits.savings ||
        !this.state.benefits.convenience ? (
          <div className={classes.loader}>
            <img src={spinner} alt="" />
            <span>Loading ...</span>
          </div>
        ) : (
          <div className={classes.content}>
            <Route
              render={({ location }) => (
                <TransitionGroup>
                  <CSSTransition
                    key={location.key}
                    timeout={500}
                    classNames="fade"
                    unmountOnExit
                  >
                    <Switch location={location}>
                      <Route
                        path="/"
                        exact
                        render={() => (
                          <FormStart
                            {...this.state.selectedChoices}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                          />
                        )}
                      />
                      {/* <Route
                        path="/seatingmap"
                        render={() => (
                          <SeatingMap
                            seatsInfo={[{ name: "Outfield Reserved" }]}
                            seatInfoSelectedKey={0}
                          />
                        )}
                      /> */}
                      <Route
                        path="/style-of-plan"
                        render={() => (
                          <FormStyleOfPlan
                            {...this.state.selectedChoices}
                            history={this.props.history}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                          />
                        )}
                      />
                      <Route
                        path="/ticket-large-group"
                        render={() => (
                          <TicketLargeGroup
                            updateSelectedChoices={this.updateSelectedChoices}
                          />
                        )}
                      />
                      <Route
                        path="/size-of-plan"
                        render={() => (
                          <FormSizeOfPlan
                            {...this.state.selectedChoices}
                            history={this.props.history}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                            cms={this.state.cms}
                          />
                        )}
                      />
                      <Route
                        path="/benefits"
                        render={() => (
                          <FormBenefits
                            {...this.state.selectedChoices}
                            history={this.props.history}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                            benefits={{
                              exclusivity: this.state.benefits.exclusivity,
                              savings: this.state.benefits.savings,
                              convenience: this.state.benefits.convenience,
                            }}
                            cms={this.state.cms}
                          />
                        )}
                      />
                      <Route
                        path="/recommended-plan"
                        render={() => (
                          <FormChooseMySeats
                            {...this.state.selectedChoices}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                            history={this.props.history}
                            cms={this.state.cms}
                          />
                        )}
                      />
                      <Route
                        path="/select-your-seats"
                        render={() => (
                          <FormSelectYourSeat
                            {...this.state.selectedChoices}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                            history={this.props.history}
                            cms={this.state.cms}
                          />
                        )}
                      />
                      <Route
                        path="/checkout"
                        render={() => (
                          <Checkout
                            {...this.state.selectedChoices}
                            updateSelectedChoices={this.updateSelectedChoices}
                            history={this.props.history}
                            cms={this.state.cms}
                          />
                        )}
                      />
                    </Switch>
                  </CSSTransition>
                </TransitionGroup>
              )}
            />
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(FormBuilder);
